import { BUDGET, NAME } from '../../../fields'

export const initialValues = {
  [NAME]: '',
  [BUDGET]: ''
}
